import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { useState } from "react";
import useSWR from "swr";
import { JSONSafe } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { TenantPlanResponse } from "@/pages/api/tenant/plan";

export const SubscribeDialog = ({ onClose }: { onClose?: () => void }) => {
  const [open, setOpen] = useState(true);
  const { data: tenant } = useSWR<JSONSafe<TenantPlanResponse>>("/api/tenant/plan");
  const planId = tenant?.planId;

  return (
    <Dialog
      open={open}
      onOpenChange={open => {
        if (!open) {
          setOpen(false);
        }

        if (onClose) {
          onClose();
        }
      }}
    >
      <DialogContent className="sm:max-w-[425px] p-12" showCloseButton>
        <DialogHeader className="mb-4">
          <DialogTitle className="text-2xl flex items-center justify-center gap-2">
            {planId
              ? "Upgrade your plan"
              : process.env.NEXT_PUBLIC_FREE_TRIAL_DAYS
                ? "Subscribe for free trial"
                : "Subscribe now"}
          </DialogTitle>
          <DialogDescription className="text-center">
            {planId
              ? "You have reached the limit of your plan. Please upgrade to continue."
              : "Please subscribe to create more apps and hosts."}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2">
          <Button asChild>
            <Link href="/pricing">
              {planId
                ? "Upgrade now"
                : process.env.NEXT_PUBLIC_FREE_TRIAL_DAYS
                  ? "Subscribe for free trial"
                  : "Subscribe now"}
            </Link>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
